// Studyo Today Backend
// Package studyo.today.schedules.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/schedules/v1/resources/activity_schedule_exception.proto (package studyo.today.schedules.v1.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_google_type_date } from "@buf/googleapis_googleapis.bufbuild_es/google/type/date_pb.js";
import { file_studyo_today_schedules_v1_resources_activity } from "./activity_pb.js";

/**
 * Describes the file studyo/today/schedules/v1/resources/activity_schedule_exception.proto.
 */
export const file_studyo_today_schedules_v1_resources_activity_schedule_exception = /*@__PURE__*/
  fileDesc("CkVzdHVkeW8vdG9kYXkvc2NoZWR1bGVzL3YxL3Jlc291cmNlcy9hY3Rpdml0eV9zY2hlZHVsZV9leGNlcHRpb24ucHJvdG8SI3N0dWR5by50b2RheS5zY2hlZHVsZXMudjEucmVzb3VyY2VzIuMBChlBY3Rpdml0eVNjaGVkdWxlRXhjZXB0aW9uEh8KBGRhdGUYASABKAsyES5nb29nbGUudHlwZS5EYXRlEhQKDHBlcmlvZF9sYWJlbBgCIAEoCRI/CghhY3Rpdml0eRgDIAEoCzItLnN0dWR5by50b2RheS5zY2hlZHVsZXMudjEucmVzb3VyY2VzLkFjdGl2aXR5EhIKCmlzX3NraXBwZWQYBCABKAgSEQoJcm9vbV9uYW1lGAUgASgJEhAKCHJldmlzaW9uGAYgASgFEhUKDXNob3VsZF9kZWxldGUYByABKAhCK6oCKFN0dWR5by5Ub2RheS5TY2hlZHVsZXMuR3JwYy5WMS5SZXNvdXJjZXNiBnByb3RvMw", [file_google_type_date, file_studyo_today_schedules_v1_resources_activity]);

/**
 * Describes the message studyo.today.schedules.v1.resources.ActivityScheduleException.
 * Use `create(ActivityScheduleExceptionSchema)` to create a new message.
 */
export const ActivityScheduleExceptionSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_schedules_v1_resources_activity_schedule_exception, 0);

